import React, { useState, useEffect } from "react";
import Images from "../Helper/AllImages";
import data from "../Helper/Data/TransactionHistory";
import { Modal } from "react-bootstrap";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css";
import { DateRangePicker, Calendar } from "react-date-range";
import { addDays } from "date-fns";
import browserRoute from "../../Routes/browserRoutes";
import { Link, useHistory } from "react-router-dom";

import { useSelector, useDispatch } from "react-redux";
import { ETHERSCAN_URL, VIEWBLOCK_URL } from "../../Routes/serverRoutes";

const Activity = () => {
  const keyStoreInstance = useSelector((state) => state.main);

  const [exportModal, setExportModal] = useState(false);
  const [transactionHistory, setTransactionHistory] = useState([]);
  const [transactionHistoryFinalized, setTransactionHistoryFinalized] =
    useState([]);
  const [mainState, setMainState] = useState([]);
  const [tempData, setTempData] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [toggle, setToggle] = useState(false);
  const [EnumRanges, setEnumRanges] = useState({
    CUSTOM_RANGE: "CUSTOM RANGE",
    ONE_DAY: "ONE DAY",
    ONE_WEEK: "ONE WEEK",
    ONE_MONTH: "ONE MONTH",
    ONE_YEAR: "ONE YEAR",
    ALL_TIME: "ALL TIME",
  });
  const [rangeType, setRangeType] = useState(EnumRanges.ALL_TIME);
  const [customToggle, setCustomToggle] = useState(false);
  const [state, setState] = useState([
    {
      startDate: new Date(),
      // endDate: addDays(new Date(), 7),
      endDate: new Date(),
      key: "selection",
    },
  ]);
  const [selectedOption, setSelectedOption] = useState({
    oneDay: false,
    oneWeek: false,
    oneMonth: false,
    oneYear: false,
    allTime: true,
  });

  useEffect(() => {
    setState([
      {
        startDate: new Date(),
        // endDate: addDays(new Date(), 7),
        endDate: new Date(),
        key: "selection",
      },
    ]);
  }, [toggle]);

  useEffect(() => {
    console.log(
      "<><><><>><><>< FINALIZED STATE <><><><><><><><><>< ",
      transactionHistoryFinalized
    );
  }, [transactionHistoryFinalized]);

  const [Enum, set_Enum] = useState({
    allType: "allType",
    withdraw: "withdraw",
    deposit: "deposit",
    pending: "pending",
    refund: "refund",
    addLiquidity: "addLiquidity",
  });
  const [filterType, setFilterType] = useState(Enum.allType);

  useEffect(() => {
    if (toggle) {
      const weekDay = document.getElementsByClassName("rdrWeekDay");
      console.log("weekDay========>>>", weekDay);
      console.log("weekDay========>>>", weekDay[0].innerHTML);
      for (let i = 0; i < weekDay.length; i++) {
        console.log("week" + i, weekDay[i].innerHTML);
        // weekDay[i].innerText = "some";
        switch (weekDay[i].innerText) {
          case "Sun":
            weekDay[i].innerText = "Su";
            break;
          case "Mon":
            weekDay[i].innerText = "Mo";
            break;
          case "Tue":
            weekDay[i].innerText = "Tu";
            break;
          case "Wed":
            weekDay[i].innerText = "We";
            break;
          case "Thu":
            weekDay[i].innerText = "Th";
            break;
          case "Fri":
            weekDay[i].innerText = "Fr";
            break;
          case "Sat":
            weekDay[i].innerText = "Sa";
            break;
          default:
            break;
        }
      }
    }
  }, [toggle]);

  useEffect(() => {
    setMainState(keyStoreInstance.transactionHistory);
  }, [
    keyStoreInstance.KeyStoreClient,
    keyStoreInstance.transactionHistory,
    keyStoreInstance,
  ]);

  useEffect(() => {
    console.log("MAINSET");
    setTransactionHistoryFinalized(keyStoreInstance.transactionHistory);
    setTempData(keyStoreInstance.transactionHistory);
  }, mainState);

  function SearchFilter(e) {
    setSearchInput(e.target.value);

    if (!e.target.value) {
      setTransactionHistoryFinalized(tempData);
    } else {
      let temp = tempData;
      console.log("hey Temp=====>>", temp);

      let res = temp?.filter(
        (value) =>
          value?.hash?.toLowerCase().includes(e.target.value.toLowerCase()) &&
          value
      );
      setTransactionHistoryFinalized(res);
    }
  }
  function filterAllType() {
    setSearchInput("");
    setFilterType(Enum.allType);
    setTransactionHistoryFinalized(mainState);
    setTempData(mainState);
  }
  function filterWithdrawType() {
    setSearchInput("");
    setFilterType(Enum.withdraw);

    let res = mainState?.filter(
      (value) => value.type.toLowerCase() === Enum.withdraw
    );

    setTransactionHistoryFinalized(res);
    setTempData(res);
  }

  function filterAddLiquidity() {
    setSearchInput("");
    setFilterType(Enum.addLiquidity);

    let res = mainState?.filter(
      (value) => value.type.toLowerCase() === Enum.addLiquidity
    );

    setTransactionHistory(res);
    setTempData(res);
  }

  function filterDepositType() {
    setSearchInput("");
    setFilterType(Enum.deposit);
    let res = mainState?.filter(
      (value) => value.type.toLowerCase() === Enum.deposit
    );

    setTransactionHistoryFinalized(res);
    setTempData(res);
  }
  function filterPendingType() {
    setSearchInput("");
    setFilterType(Enum.pending);
    let res = mainState?.filter(
      (value) => value.type.toLowerCase() === Enum.pending
    );

    setTransactionHistoryFinalized(res);
    setTempData(res);
  }

  function filterRefundType() {
    setSearchInput("");
    setFilterType(Enum.refund);
    let res = mainState?.filter(
      (value) => value.type.toLowerCase() === Enum.refund
    );

    setTransactionHistoryFinalized(res);
    setTempData(res);
  }

  //CUSTOM HANDLER
  const handleCustom = (item) => {
    setYearSelected(false);
    setMonthSelected(false);
    setDaySelected(false);
    setWeekSelected(false);
    setCustomSelected(true);
    setAllTimeSelected(false);
    setRangeType(EnumRanges.CUSTOM_RANGE);

    const newState = [...state];

    //for filteration
    let dateFilter = tempData?.filter((value) => {
      console.log("value========", value.date);
      let tempDate = new Date(value.date);
      tempDate.setHours(0);
      tempDate.setMinutes(0);
      tempDate.setSeconds(0);
      tempDate.setMilliseconds(0);
      newState[0].startDate.setHours(0);
      newState[0].startDate.setMinutes(0);
      newState[0].startDate.setSeconds(0);
      newState[0].startDate.setMilliseconds(0);

      newState[0].endDate.setHours(0);
      newState[0].endDate.setMinutes(0);
      newState[0].endDate.setSeconds(0);
      newState[0].endDate.setMilliseconds(0);

      console.log("time1===>>>", tempDate);
      console.log("time2===>>>", newState);

      return (
        tempDate >= newState[0].startDate &&
        tempDate <= newState[0].endDate &&
        value
      );
    });

    setTransactionHistory(dateFilter);
  };
  //ALL TIME HANDLER
  const handleAllTime = () => {
    setYearSelected(false);
    setMonthSelected(false);
    setDaySelected(false);
    setWeekSelected(false);
    setCustomSelected(false);
    setAllTimeSelected(true);

    setSelectedOption({
      oneDay: false,
      oneWeek: false,
      oneMonth: false,
      oneYear: false,
      allTime: true,
    });

    setRangeType(EnumRanges.ALL_TIME);
    setTransactionHistory(mainState);
    setCustomToggle(false);

    // setToggle(false);

    //Reset to current day
    const newState = [...state];
    newState[0].startDate = new Date();

    newState[0].endDate = new Date();
    newState[0].key = "selection";

    setState(newState);
    //for filteration
    let dateFilter =
      // console.log("record", d);
      tempData?.filter((value) => {
        let tempDate = new Date(value.date);
        let actualDate = new Date();
        console.log("Date====>>", tempDate.getFullYear());
        return (
          tempDate.getMonth() == actualDate.getMonth() &&
          tempDate.getFullYear() == actualDate.getFullYear() &&
          tempDate.getDate() == actualDate.getDate() &&
          value
        );
      });

    setTransactionHistory(dateFilter);
  };

  //ONE DAY HANDLER
  const handleOneDay = () => {
    setYearSelected(false);
    setMonthSelected(false);
    setDaySelected(true);
    setWeekSelected(false);
    setCustomSelected(false);
    setAllTimeSelected(false);

    setSelectedOption({
      oneDay: true,
      oneWeek: false,
      oneMonth: false,
      oneYear: false,
      allTime: false,
    });
    setRangeType(EnumRanges.ONE_DAY);
    setCustomToggle(false);
    // const newState = [...state];
    // newState[0].startDate = new Date();

    // newState[0].endDate = new Date();

    // setState(newState);

    //for filteration
    let dateFilter =
      // console.log("record", d);
      tempData?.filter((value) => {
        let tempDate = new Date(value.date);
        let actualDate = new Date(state[0].endDate);
        console.log("Salis=======", actualDate);
        console.log("Date====>>", tempDate.getFullYear());
        return (
          tempDate.getMonth() == actualDate.getMonth() &&
          tempDate.getFullYear() == actualDate.getFullYear() &&
          tempDate.getDate() == actualDate.getDate() &&
          value
        );
      });

    setTransactionHistory(dateFilter);
  };

  //One Week Handler

  const handleOneWeek = () => {
    setYearSelected(false);
    setMonthSelected(false);
    setDaySelected(false);
    setWeekSelected(true);
    setCustomSelected(false);
    setAllTimeSelected(false);

    setSelectedOption({
      oneDay: false,
      oneWeek: true,
      oneMonth: false,
      oneYear: false,
      allTime: false,
    });
    setRangeType(EnumRanges.ONE_WEEK);
    setCustomToggle(false);

    let curr = new Date();

    let yesterday = new Date();
    console.log("<><> 1WEEK ", state);
    yesterday.setDate(state[0].startDate.getDate());

    let week = [];

    for (let i = 1; i <= 7; i++) {
      let first = yesterday.getDate() - yesterday.getDay() + i;

      let day = new Date(yesterday.setDate(first)).toISOString().slice(0, 10);
      console.log("<><>><<> WEEK SETUP <> ", day);
      week.push(day);
    }
    const newState = [...state];
    newState[0].startDate = new Date(week[0]);

    newState[0].endDate = new Date(week[week.length - 1]);
    setState(newState);
    let start = new Date(week[0]);
    let end = new Date(week[week.length - 1]);
    start.setHours(0);
    start.setMinutes(0);
    start.setSeconds(0);
    start.setMilliseconds(0);
    end.setHours(0);
    end.setMinutes(0);
    end.setSeconds(0);
    end.setMilliseconds(0);
    //for filteration
    let dateFilter = tempData?.filter((value) => {
      let tempDate = new Date(value.date);
      tempDate.setHours(0);
      tempDate.setMinutes(0);
      tempDate.setSeconds(0);
      tempDate.setMilliseconds(0);
      console.log("Date====>>", tempDate.getFullYear());
      return tempDate >= start && tempDate <= end && value;
    });

    setTransactionHistory(dateFilter);
  };
  //ONE MONTH HANDLER
  function daysInMonth(month, year) {
    return new Date(year, month, 0).getDate();
  }
  const handleOneMonth = () => {
    setYearSelected(false);
    setMonthSelected(true);
    setDaySelected(false);
    setWeekSelected(false);
    setCustomSelected(false);
    setAllTimeSelected(false);

    setSelectedOption({
      oneDay: false,
      oneWeek: false,
      oneMonth: true,
      oneYear: false,
      allTime: false,
    });
    setRangeType(EnumRanges.ONE_MONTH);
    setCustomToggle(false);
    // for date Component
    // const newStateMain = [...state];
    // console.log("====>>>", newStateMain);

    // const date = new Date(newStateMain[0].endDate);
    // var month = date.getMonth() + 1;
    // var year = date.getFullYear();
    // let res = daysInMonth(month, year);
    // let startDate = new Date(1);
    // startDate.setMonth(date.getMonth());
    // startDate.setFullYear(date.getFullYear());
    // console.log("res====>>>", res);

    // let endDate = new Date();
    // endDate.setMonth(date.getMonth());
    // endDate.setFullYear(date.getFullYear());
    // endDate.setDate(res);

    // const newState = [...state];
    // newState[0].startDate = new Date(startDate);

    // newState[0].endDate = new Date(endDate);
    // setState(newState);
    // //for filteration
    // let dateFilter = tempData?.filter((value) => {
    //   // console.log("value========", value);
    //   let tempDate = new Date(value.date);
    //   let actualDate = new Date(newStateMain[0].endDate);

    //   return (
    //     tempDate.getMonth() == actualDate.getMonth() &&
    //     tempDate.getFullYear() == actualDate.getFullYear() &&
    //     value
    //   );
    // });

    // setTransactionHistory(dateFilter);

    //Reset to current day
    const newState = [...state];
    newState[0].startDate = new Date();

    newState[0].endDate = new Date();
    setState(newState);
    //for filteration
    let dateFilter =
      // console.log("record", d);
      tempData?.filter((value) => {
        let tempDate = new Date(value.date);
        console.log("Date VALUE>DATE====>>", value);
        let actualDate = new Date();
        console.log("Date====>>", tempDate.getFullYear());
        return (
          tempDate.getMonth() == monthState &&
          tempDate.getFullYear() == yearState &&
          // tempDate.getDate() == actualDate.getDate() &&
          value
        );
      });

    setTransactionHistory(dateFilter);
  };
  //ONE YEAR HANDLER
  const handleOneYear = () => {
    setYearSelected(true);
    setMonthSelected(false);
    setDaySelected(false);
    setWeekSelected(false);
    setCustomSelected(false);
    setAllTimeSelected(false);

    setSelectedOption({
      oneDay: false,
      oneWeek: false,
      oneMonth: false,
      oneYear: true,
      allTime: false,
    });
    setRangeType(EnumRanges.ONE_YEAR);
    setCustomToggle(false);
    // for date Component
    // const date = new Date();

    // let startDate = new Date(1);
    // startDate.setFullYear(date.getFullYear());
    // startDate.setMonth(0);
    // let endDate = new Date();
    // endDate.setFullYear(date.getFullYear());
    // endDate.setMonth(11);
    // endDate.setDate(31);
    // const newState = [...state];
    // newState[0].startDate = new Date(startDate);

    // newState[0].endDate = new Date(endDate);
    // setState(newState);
    // //for filteration
    // let dateFilter = tempData?.filter((value) => {
    //   // console.log("value========", value);
    //   let tempDate = new Date(value.date);
    //   let actualDate = new Date();
    //   console.log("Date====>>", tempDate.getFullYear());
    //   return tempDate.getFullYear() == actualDate.getFullYear() && value;
    // });

    // setTransactionHistory(dateFilter);

    //Reset to current day
    const newState = [...state];
    newState[0].startDate = new Date();

    newState[0].endDate = new Date();
    setState(newState);
    //for filteration
    let dateFilter =
      // console.log("record", d);
      tempData?.filter((value) => {
        let tempDate = new Date(value.date);
        let actualDate = new Date();
        console.log("Date====>>", tempDate.getFullYear());
        return (
          tempDate.getMonth() == actualDate.getMonth() &&
          tempDate.getFullYear() == actualDate.getFullYear() &&
          tempDate.getDate() == actualDate.getDate() &&
          value
        );
      });

    setTransactionHistory(dateFilter);
  };
  const handleCustomRange = () => {
    setRangeType(EnumRanges.CUSTOM_RANGE);
    setCustomToggle(true);
  };
  function downloadCSVFile(csv_data) {
    // Create CSV file object and feed our

    // csv_data into it

    let CSVFile = new Blob([csv_data], { type: "text/csv" });

    // Create to temporary link to initiate

    // download process

    var temp_link = document.createElement("a");

    // Download csv file

    temp_link.download = "DefiSpot.csv";

    var url = window.URL.createObjectURL(CSVFile);

    temp_link.href = url;

    // This link should not be displayed

    temp_link.style.display = "none";

    document.body.appendChild(temp_link);

    // Automatically click the link to trigger download

    temp_link.click();

    document.body.removeChild(temp_link);
  }
  function tableToCSV() {
    // Variable to store the final csv data

    var csv_data = [];

    // Get each row data

    var rows = document.getElementsByTagName("tr");

    for (var i = 0; i < rows.length; i++) {
      var cols = rows[i].querySelectorAll("span,p");

      var csvrow = [];

      for (var j = 0; j < cols.length; j++) {
        // csvrow.push(cols[j].innerHTML);
        // console.log("myString====>>>", cols[j].innerHTML);
        let s = cols[j].innerHTML.split(" ");
        let newString = "";

        for (let m = 0; m < s.length; m++) {
          newString = newString + s[m];
        }
        csvrow.push(newString);
      }

      csv_data.push(csvrow.join(","));
    }

    csv_data = csv_data.join("\n");
    // console.log(csv_data);
    downloadCSVFile(csv_data);
  }

  const [ascendingDescendingCoin, setAscendingDescendingCoin] = useState(false);
  const [ascendingDescendingAmount, setAscendingDescendingAmount] =
    useState(false);
  const [ascendingDescendingAddress, setAscendingDescendingAddress] =
    useState(false);
  const [
    ascendingDescendingTransactionID,
    setAscendingDescendingTransactionID,
  ] = useState(false);

  const handleAscendingDescendingCoin = () => {
    setAscendingDescendingCoin(!ascendingDescendingCoin);
    if (ascendingDescendingCoin) {
      handleAscendingCoin();
    } else {
      handleDescendingCoin();
    }
  };

  const handleAscendingDescendingAmount = () => {
    setAscendingDescendingAmount(!ascendingDescendingAmount);
    if (ascendingDescendingAmount) {
      handleAscendingAmount();
    } else {
      handleDescendingAmount();
    }
  };

  const handleAscendingDescendingAddress = () => {
    setAscendingDescendingAddress(!ascendingDescendingAddress);
    if (ascendingDescendingAddress) {
      handleAscendingAddress();
    } else {
      handleDescendingAddress();
    }
  };

  const handleAscendingDescendingTransactionID = () => {
    setAscendingDescendingTransactionID(!ascendingDescendingTransactionID);
    if (ascendingDescendingTransactionID) {
      handleAscendingTransactionID();
    } else {
      handleDescendingTransactionID();
    }
  };

  //Descending Order Filter Type
  const handleDescendingType = () => {
    let check = [...mainState];
    let res = check.sort((a, b) =>
      a.type.toLowerCase() < b.type.toLowerCase() ? 1 : -1
    );

    setMainState(res);
    let check2 = [...transactionHistoryFinalized];
    let res2 = check2.sort((a, b) =>
      a.type.toLowerCase() < b.type.toLowerCase() ? 1 : -1
    );
    setTransactionHistoryFinalized(res2);
    let check3 = [...tempData];
    let res3 = check3.sort((a, b) =>
      a.type.toLowerCase() < b.type.toLowerCase() ? 1 : -1
    );
    setTempData(res3);
  };

  //Ascending Order Filter Type
  const handleAscendingType = () => {
    let check = [...mainState];
    let res = check.sort((a, b) =>
      a.type.toLowerCase() > b.type.toLowerCase() ? 1 : -1
    );

    setMainState(res);
    let check2 = [...transactionHistoryFinalized];
    let res2 = check2.sort((a, b) =>
      a.type.toLowerCase() > b.type.toLowerCase() ? 1 : -1
    );
    setTransactionHistoryFinalized(res2);
    let check3 = [...tempData];
    let res3 = check3.sort((a, b) =>
      a.type.toLowerCase() > b.type.toLowerCase() ? 1 : -1
    );
    setTempData(res3);
  };

  //Descending Order Filter Coin
  const handleDescendingCoin = () => {
    console.log("Fun running descending ");

    let check = [...mainState];
    let res = check.sort((a, b) =>
      a.asset.ticker.toLowerCase() < b.asset.ticker.toLowerCase() ? 1 : -1
    );
    console.log("<><>< Descending main state <><>< ", res);

    setMainState(res);
    let check2 = [...transactionHistoryFinalized];
    let res2 = check2.sort((a, b) =>
      a.asset.ticker.toLowerCase() < b.asset.ticker.toLowerCase() ? 1 : -1
    );
    console.log("<><>< Descending tranFinalized state <><>< ", res2);

    setTransactionHistoryFinalized(res2);
    let check3 = [...tempData];
    let res3 = check3.sort((a, b) =>
      a.asset.ticker.toLowerCase() < b.asset.ticker.toLowerCase() ? 1 : -1
    );
    console.log("<><>< Descending tempDData state <><>< ", res3);

    setTempData(res3);
  };

  //Ascending Order Filter Coin
  const handleAscendingCoin = () => {
    console.log("Fun running ascending ");
    let check = [...mainState];
    let res = check.sort((a, b) =>
      a.asset.ticker.toLowerCase() > b.asset.ticker.toLowerCase() ? 1 : -1
    );

    console.log("<><>< Ascending main state <><>< ", res);

    setMainState(res);
    let check2 = [...transactionHistoryFinalized];
    let res2 = check2.sort((a, b) =>
      a.asset.ticker.toLowerCase() > b.asset.ticker.toLowerCase() ? 1 : -1
    );

    console.log("<><>< Ascending tranFinalized state <><>< ", res2);

    setTransactionHistoryFinalized(res2);

    let check3 = [...tempData];
    let res3 = check3.sort((a, b) =>
      a.asset.ticker.toLowerCase() > b.asset.ticker.toLowerCase() ? 1 : -1
    );

    console.log("<><>< Ascending tempDData state <><>< ", res3);

    setTempData(res3);
  };

  //Descending Order Filter Amount
  const handleDescendingAmount = () => {
    let check = [...mainState];
    let res = check.sort((a, b) => b.transferAmount - a.transferAmount);

    setMainState(res);
    let check2 = [...transactionHistoryFinalized];
    let res2 = check2.sort((a, b) => b.transferAmount - a.transferAmount);
    setTransactionHistoryFinalized(res2);
    let check3 = [...tempData];
    let res3 = check3.sort((a, b) => b.transferAmount - a.transferAmount);
    setTempData(res3);
  };

  //Ascending Order Filter Amount
  const handleAscendingAmount = () => {
    let check = [...mainState];
    let res = check.sort((a, b) => a.transferAmount - b.transferAmount);

    setMainState(res);
    let check2 = [...transactionHistoryFinalized];
    let res2 = check2.sort((a, b) => a.transferAmount - b.transferAmount);
    setTransactionHistoryFinalized(res2);
    let check3 = [...tempData];
    let res3 = check3.sort((a, b) => a.transferAmount - b.transferAmount);
    setTempData(res3);
  };

  //Descending Order Filter Address
  const handleDescendingAddress = () => {
    let check = [...mainState];
    let res = check?.sort((a, b) =>
      a.to[0].to.toLowerCase() < b.to[0].to.toLowerCase() ? 1 : -1
    );

    setMainState(res);
    let check2 = [...transactionHistoryFinalized];
    let res2 = check2?.sort((a, b) =>
      a.to[0].to.toLowerCase() < b.to[0].to.toLowerCase() ? 1 : -1
    );
    setTransactionHistoryFinalized(res2);
    let check3 = [...tempData];
    let res3 = check3?.sort((a, b) =>
      a.to[0].to.toLowerCase() < b.to[0].to.toLowerCase() ? 1 : -1
    );
    setTempData(res3);
  };

  //Ascending Order Filter Type
  const handleAscendingAddress = () => {
    let check = [...mainState];
    let res = check?.sort((a, b) =>
      a.to[0].to.toLowerCase() > b.to[0].to.toLowerCase() ? 1 : -1
    );

    setMainState(res);
    let check2 = [...transactionHistoryFinalized];
    let res2 = check2?.sort((a, b) =>
      a.to[0].to.toLowerCase() > b.to[0].to.toLowerCase() ? 1 : -1
    );
    setTransactionHistoryFinalized(res2);
    let check3 = [...tempData];
    let res3 = check3?.sort((a, b) =>
      a.to[0].to.toLowerCase() > b.to[0].to.toLowerCase() ? 1 : -1
    );
    setTempData(res3);
  };

  //Descending Order Filter TransactionID
  const handleDescendingTransactionID = () => {
    let check = [...mainState];
    let res = check.sort((a, b) =>
      a.hash.toLowerCase() < b.hash.toLowerCase() ? 1 : -1
    );

    setMainState(res);
    let check2 = [...transactionHistoryFinalized];
    let res2 = check2.sort((a, b) =>
      a.hash.toLowerCase() < b.hash.toLowerCase() ? 1 : -1
    );
    setTransactionHistoryFinalized(res2);
    let check3 = [...tempData];
    let res3 = check3.sort((a, b) =>
      a.hash.toLowerCase() < b.hash.toLowerCase() ? 1 : -1
    );
    setTempData(res3);
  };

  //Ascending Order Filter TransactionID
  const handleAscendingTransactionID = () => {
    let check = [...mainState];
    let res = check.sort((a, b) =>
      a.hash.toLowerCase() > b.hash.toLowerCase() ? 1 : -1
    );

    setMainState(res);
    let check2 = [...transactionHistoryFinalized];
    let res2 = check2.sort((a, b) =>
      a.hash.toLowerCase() > b.hash.toLowerCase() ? 1 : -1
    );
    setTransactionHistoryFinalized(res2);
    let check3 = [...tempData];
    let res3 = check3.sort((a, b) =>
      a.hash.toLowerCase() > b.hash.toLowerCase() ? 1 : -1
    );
    setTempData(res3);
  };

  const gettingLogos = (t) => {
    let midgardPool = keyStoreInstance?.midgardPool;
    let ticker = t?.asset?.ticker;
    if (t.asset.ticker.toLowerCase() === "rune") {
      return (
        <>
          <img style={{ width: "25px" }} src={Images.runeImg} />
        </>
      );
    } else {
      let res = midgardPool?.find(
        (d) => d?.asset.toLowerCase() === ticker.toLowerCase()
      );
      return (
        <>
          <img style={{ width: "25px" }} src={res.logo} />
        </>
      );
    }
  };

  const [yearSelected, setYearSelected] = useState(false);
  const [monthSelected, setMonthSelected] = useState(false);
  const [weekSelected, setWeekSelected] = useState(false);
  const [daySelected, setDaySelected] = useState(false);
  const [customSelected, setCustomSelected] = useState(false);
  const [allTimeSelected, setAllTimeSelected] = useState(true);
  const [monthState, setMonthState] = useState(new Date().getMonth() + 1);
  const [yearState, setYearState] = useState(new Date().getFullYear());
  const [monthName, setMonthName] = useState(
    monthState == 1
      ? "January"
      : monthState == 2
      ? "February"
      : monthState == 3
      ? "March"
      : monthState == 4
      ? "April"
      : monthState == 5
      ? "May"
      : monthState == 6
      ? "June"
      : monthState == 7
      ? "July"
      : monthState == 8
      ? "August"
      : monthState == 9
      ? "September"
      : monthState == 10
      ? "October"
      : monthState == 11
      ? "November"
      : monthState == 12
      ? "December"
      : null
  );

  const months = [
    { val: 1, name: "January" },
    { val: 2, name: "February" },
    { val: 3, name: "March" },
    { val: 4, name: "April" },
    { val: 5, name: "May" },
    { val: 6, name: "June" },
    { val: 7, name: "July" },
    { val: 8, name: "August" },
    { val: 9, name: "September" },
    { val: 10, name: "October" },
    { val: 11, name: "November" },
    { val: 12, name: "December" },
  ];

  useEffect(() => {
    if (yearSelected || monthSelected) {
      setYearSelected(true);
      setMonthSelected(false);
      setDaySelected(false);
      setWeekSelected(false);
      setCustomSelected(false);

      setSelectedOption({
        oneDay: false,
        oneWeek: false,
        oneMonth: false,
        oneYear: true,
        allTime: false,
      });

      setRangeType(EnumRanges.ONE_YEAR);
      setCustomToggle(false);
      // for date Component
      const date = new Date();

      let startDate = new Date(1);
      startDate.setFullYear(yearState);
      startDate.setMonth(0);
      let endDate = new Date();
      endDate.setFullYear(yearState);
      endDate.setMonth(11);
      endDate.setDate(31);
      const newState = [...state];
      newState[0].startDate = new Date(startDate);

      newState[0].endDate = new Date(endDate);
      setState(newState);
      //for filteration
      let dateFilter = tempData?.filter((value) => {
        // console.log("value========", value);
        let tempDate = new Date(value.date);
        let actualDate = new Date();
        console.log("Date====>>", tempDate.getFullYear());
        return tempDate.getFullYear() == actualDate.getFullYear() && value;
      });

      setTransactionHistory(dateFilter);
    }
  }, [yearState]);

  useEffect(() => {
    if (monthSelected) {
      setYearSelected(false);
      setMonthSelected(true);
      setDaySelected(false);
      setWeekSelected(false);
      setCustomSelected(false);

      setSelectedOption({
        oneDay: false,
        oneWeek: false,
        oneMonth: true,
        oneYear: false,
        allTime: true,
      });
      setRangeType(EnumRanges.ONE_MONTH);
      setCustomToggle(false);
      // for date Component
      const newStateMain = [...state];
      console.log("====>>>", newStateMain);

      const date = new Date(newStateMain[0].endDate);
      var month = date.getMonth() + 1;
      var year = date.getFullYear();
      let res = daysInMonth(month, year);
      let startDate = new Date(1);
      startDate.setMonth(monthState - 1);
      startDate.setFullYear(yearState);
      console.log("res====>>>", res);

      let endDate = new Date();
      endDate.setMonth(monthState - 1);
      endDate.setFullYear(yearState);
      endDate.setDate(res);

      const newState = [...state];
      newState[0].startDate = new Date(startDate);

      newState[0].endDate = new Date(endDate);
      setState(newState);
      //for filteration
      let dateFilter = tempData?.filter((value) => {
        // console.log("value========", value);
        let tempDate = new Date(value.date);
        let actualDate = new Date(newStateMain[0].endDate);

        return (
          tempDate.getMonth() == actualDate.getMonth() &&
          tempDate.getFullYear() == actualDate.getFullYear() &&
          value
        );
      });

      setTransactionHistory(dateFilter);

      setMonthName(
        monthState == 1
          ? "January"
          : monthState == 2
          ? "February"
          : monthState == 3
          ? "March"
          : monthState == 4
          ? "April"
          : monthState == 5
          ? "May"
          : monthState == 6
          ? "June"
          : monthState == 7
          ? "July"
          : monthState == 8
          ? "August"
          : monthState == 9
          ? "September"
          : monthState == 10
          ? "October"
          : monthState == 11
          ? "November"
          : monthState == 12
          ? "December"
          : null
      );
    }
  }, [monthState]);

  const viewBlockLink = (t) => {
    let link;
    if (t?.asset?.chain === "ETH") {
      link = `https://${ETHERSCAN_URL}etherscan.io/tx/${t?.hash}`;
    } else {
      link = `https://viewblock.io/thorchain/tx/${t?.hash}${VIEWBLOCK_URL}`;
    }
    return (
      <>
        <a href={`${link}`} target="_blank">
          {t?.hash?.substring(0, 7)}...
        </a>
      </>
    );
  };

  //CUSTOM RANGE HANDLER
  return (
    <div className="col-lg-10 pl-0" style={{ paddingRight: "8px" }}>
      {/*Date Modal*/}
      <Modal
        show={toggle}
        onHide={() => {
          setToggle(false);
        }}
        keyboard={false}
        size="lg"
      >
        <Modal.Body>
          {/* <!-- Modal --> */}
          <div
            id="exampleModal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div role="document">
              <div>
                <div
                  class="modal-body p-0"
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <div class="d-flex flex-column">
                    <div class="d-flex flex-row justify-content-center">
                      <div class="dropdown n-learnSectionDropDown">
                        <button
                          disabled={
                            yearSelected ||
                            daySelected ||
                            customSelected ||
                            weekSelected ||
                            allTimeSelected
                          }
                          class="btn btn-secondary234"
                          type="button"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                          style={{ fontWeight: "500" }}
                        >
                          {/* January */}
                          {monthName}
                          <svg
                            width="32"
                            height="32"
                            viewBox="0 0 32 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="ml-2 ml-md-5"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M20.2071 13.7929C19.8166 13.4024 19.1834 13.4024 18.7929 13.7929L16 16.5858L13.2071 13.7929C12.8166 13.4024 12.1834 13.4024 11.7929 13.7929C11.4024 14.1834 11.4024 14.8166 11.7929 15.2071L15.2929 18.7071C15.6834 19.0976 16.3166 19.0976 16.7071 18.7071L20.2071 15.2071C20.5976 14.8166 20.5976 14.1834 20.2071 13.7929Z"
                              fill="#777E91"
                            />
                            <rect
                              x="1"
                              y="1"
                              width="30"
                              height="30"
                              rx="15"
                              stroke="#FCFCFD"
                              stroke-width="2"
                            />
                          </svg>
                        </button>
                        <div
                          style={{
                            width: "100%",
                            borderRadius: "10px",
                            border: "2px solid #e6e8ec",
                          }}
                          class="dropdown-menu n-dropdownMenuShow"
                          aria-labelledby="dropdownMenuButton"
                        >
                          <a
                            class="dropdown-item n-dropDrownItem"
                            href="#"
                            onClick={() => setMonthState(1)}
                          >
                            January
                          </a>
                          <a
                            class="dropdown-item n-dropDrownItem"
                            href="#"
                            onClick={() => setMonthState(2)}
                          >
                            February
                          </a>
                          <a
                            class="dropdown-item n-dropDrownItem"
                            href="#"
                            onClick={() => setMonthState(3)}
                          >
                            March
                          </a>
                          <a
                            class="dropdown-item n-dropDrownItem"
                            href="#"
                            onClick={() => setMonthState(4)}
                          >
                            April
                          </a>
                          <a
                            class="dropdown-item n-dropDrownItem"
                            href="#"
                            onClick={() => setMonthState(5)}
                          >
                            May
                          </a>
                          <a
                            class="dropdown-item n-dropDrownItem"
                            href="#"
                            onClick={() => setMonthState(6)}
                          >
                            June
                          </a>
                          <a
                            class="dropdown-item n-dropDrownItem"
                            href="#"
                            onClick={() => setMonthState(7)}
                          >
                            July
                          </a>
                          <a
                            class="dropdown-item n-dropDrownItem"
                            href="#"
                            onClick={() => setMonthState(8)}
                          >
                            August
                          </a>
                          <a
                            class="dropdown-item n-dropDrownItem"
                            href="#"
                            onClick={() => setMonthState(9)}
                          >
                            September
                          </a>
                          <a
                            class="dropdown-item n-dropDrownItem"
                            href="#"
                            onClick={() => setMonthState(10)}
                          >
                            October
                          </a>
                          <a
                            class="dropdown-item n-dropDrownItem"
                            href="#"
                            onClick={() => setMonthState(11)}
                          >
                            November
                          </a>
                          <a
                            class="dropdown-item n-dropDrownItem"
                            href="#"
                            onClick={() => setMonthState(12)}
                          >
                            December
                          </a>
                        </div>
                      </div>
                      <div class="dropdown n-learnSectionDropDown ml-2">
                        <button
                          disabled={
                            weekSelected ||
                            daySelected ||
                            customSelected ||
                            allTimeSelected
                          }
                          class="btn btn-secondary234"
                          type="button"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                          style={{ fontWeight: "500" }}
                        >
                          {/* 2010 */}
                          {yearState}
                          <svg
                            width="32"
                            height="32"
                            viewBox="0 0 32 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="ml-2 ml-md-5"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M20.2071 13.7929C19.8166 13.4024 19.1834 13.4024 18.7929 13.7929L16 16.5858L13.2071 13.7929C12.8166 13.4024 12.1834 13.4024 11.7929 13.7929C11.4024 14.1834 11.4024 14.8166 11.7929 15.2071L15.2929 18.7071C15.6834 19.0976 16.3166 19.0976 16.7071 18.7071L20.2071 15.2071C20.5976 14.8166 20.5976 14.1834 20.2071 13.7929Z"
                              fill="#777E91"
                            />
                            <rect
                              x="1"
                              y="1"
                              width="30"
                              height="30"
                              rx="15"
                              stroke="#FCFCFD"
                              stroke-width="2"
                            />
                          </svg>
                        </button>
                        <div
                          style={{
                            width: "100%",
                            borderRadius: "10px",
                            border: "2px solid #e6e8ec",
                          }}
                          class="dropdown-menu n-dropdownMenuShow"
                          aria-labelledby="dropdownMenuButton"
                        >
                          <a
                            class="dropdown-item n-dropDrownItem"
                            href="#"
                            onClick={() => setYearState(2010)}
                          >
                            2010
                          </a>
                          <a
                            class="dropdown-item n-dropDrownItem"
                            href="#"
                            onClick={() => setYearState(2011)}
                          >
                            2011
                          </a>
                          <a
                            class="dropdown-item n-dropDrownItem"
                            href="#"
                            onClick={() => setYearState(2012)}
                          >
                            2012
                          </a>
                          <a
                            class="dropdown-item n-dropDrownItem"
                            href="#"
                            onClick={() => setYearState(2013)}
                          >
                            2013
                          </a>
                          <a
                            class="dropdown-item n-dropDrownItem"
                            href="#"
                            onClick={() => setYearState(2014)}
                          >
                            2014
                          </a>
                          <a
                            class="dropdown-item n-dropDrownItem"
                            href="#"
                            onClick={() => setYearState(2015)}
                          >
                            2015
                          </a>
                          <a
                            class="dropdown-item n-dropDrownItem"
                            href="#"
                            onClick={() => setYearState(2016)}
                          >
                            2016
                          </a>
                          <a
                            class="dropdown-item n-dropDrownItem"
                            href="#"
                            onClick={() => setYearState(2017)}
                          >
                            2017
                          </a>
                          <a
                            class="dropdown-item n-dropDrownItem"
                            href="#"
                            onClick={() => setYearState(2018)}
                          >
                            2018
                          </a>
                          <a
                            class="dropdown-item n-dropDrownItem"
                            href="#"
                            onClick={() => setYearState(2019)}
                          >
                            2019
                          </a>
                          <a
                            class="dropdown-item n-dropDrownItem"
                            href="#"
                            onClick={() => setYearState(2020)}
                          >
                            2020
                          </a>
                          <a
                            class="dropdown-item n-dropDrownItem"
                            href="#"
                            onClick={() => setYearState(2021)}
                          >
                            2021
                          </a>
                        </div>
                      </div>
                      {/* {console.log("<><><MONTH  <><> ", new Date().getMonth())}
                      <select
                        class="mr-3"
                        disabled={yearSelected}
                        defaultValue={new Date().getMonth()}
                      >
                        <option value={1}>January</option>
                        <option value={2}>February</option>
                        <option value={3}>March</option>
                        <option value={4}>April</option>
                        <option value={5}>May</option>
                        <option value={6}>June</option>
                        <option value={7}>July</option>
                        <option value={8}>August</option>
                        <option value={9}>September</option>
                        <option value={10}>Octuber</option>
                        <option value={11}>November</option>
                        <option value={12}>December</option>
                      </select>
                      <select class="ml-3" defaultValue="2021">
                        <option value="2010">2010</option>
                        <option value="2011">2011</option>
                        <option value="2012">2012</option>
                        <option value="2013">2013</option>
                        <option value="2014">2014</option>
                        <option value="2015">2015</option>
                        <option value="2016">2016</option>
                        <option value="2017">2017</option>
                        <option value="2018">2018</option>
                        <option value="2019">2019</option>
                        <option value="2020">2020</option>
                        <option value="2021">2021</option>
                      </select> */}
                    </div>
                    <div class="d-flex flex-column flex-lg-row">
                      <div class="n-customRanger">
                        <ul>
                          <li
                            class={
                              rangeType === EnumRanges.CUSTOM_RANGE
                                ? "rangeActive"
                                : null
                            }
                            onClick={handleCustom}
                          >
                            Custom Range
                          </li>
                          <li
                            class={
                              rangeType === EnumRanges.ONE_DAY
                                ? "rangeActive"
                                : null
                            }
                            onClick={handleOneDay}
                          >
                            One Day
                          </li>
                          <li
                            class={
                              rangeType === EnumRanges.ONE_WEEK
                                ? "rangeActive"
                                : null
                            }
                            onClick={handleOneWeek}
                          >
                            One Week
                          </li>
                          <li
                            class={
                              rangeType === EnumRanges.ONE_MONTH
                                ? "rangeActive"
                                : null
                            }
                            onClick={handleOneMonth}
                          >
                            One Month
                          </li>
                          <li
                            class={
                              rangeType === EnumRanges.ONE_YEAR
                                ? "rangeActive"
                                : null
                            }
                            onClick={handleOneYear}
                          >
                            One Year
                          </li>
                          <li
                            class={
                              rangeType === EnumRanges.ALL_TIME
                                ? "rangeActive"
                                : null
                            }
                            onClick={handleAllTime}
                          >
                            All Time
                          </li>
                        </ul>
                      </div>
                      <div class="d-flex flex-column justify-content-start align-items-center w-date-model-bd">
                        <DateRangePicker
                          // staticRanges={[]}
                          // inputRanges={[]}
                          // moveRangeOnFirstSelection={true}
                          // retainEndDateOnFirstSelection={true}

                          showMonthAndYearPickers={true}
                          maxDate={
                            yearSelected || monthSelected || allTimeSelected
                              ? new Date(
                                  new Date().getTime() - 24 * 60 * 60 * 1000
                                )
                              : new Date()
                          } //disable future dates
                          minDate={
                            yearSelected || monthSelected || allTimeSelected
                              ? new Date()
                              : null
                          }
                          onChange={(item) => {
                            if (daySelected) {
                              item.selection.startDate = item.selection.endDate;
                              item.selection.endDate = item.selection.startDate;

                              setYearSelected(false);
                              setMonthSelected(false);
                              setDaySelected(true);
                              setWeekSelected(false);
                              setCustomSelected(false);
                              setAllTimeSelected(false);

                              setSelectedOption({
                                oneDay: true,
                                oneWeek: false,
                                oneMonth: false,
                                oneYear: false,
                                allTime: false,
                              });
                              setRangeType(EnumRanges.ONE_DAY);
                              setCustomToggle(false);
                              //for filteration
                              let dateFilter =
                                // console.log("record", d);
                                tempData?.filter((value) => {
                                  let tempDate = new Date(value.date);
                                  let actualDate = new Date(
                                    item.selection.startDate
                                  );
                                  // console.log("Salis=======", actualDate);
                                  // console.log(
                                  //   "Date====>>",
                                  //   tempDate.getFullYear()
                                  // );
                                  return (
                                    tempDate.getMonth() ==
                                      actualDate.getMonth() &&
                                    tempDate.getFullYear() ==
                                      actualDate.getFullYear() &&
                                    tempDate.getDate() ==
                                      actualDate.getDate() &&
                                    value
                                  );
                                });

                              setTransactionHistory(dateFilter);
                            } else if (weekSelected) {
                              setRangeType(EnumRanges.ONE_WEEK);
                              setCustomToggle(false);

                              let curr = item.selection.startDate;

                              let yesterday = item.selection.endDate;

                              yesterday.setDate(curr.getDate());

                              let week = [];

                              for (let i = 1; i <= 7; i++) {
                                let first =
                                  yesterday.getDate() - yesterday.getDay() + i;

                                let day = new Date(yesterday.setDate(first))
                                  .toISOString()
                                  .slice(0, 10);
                                console.log("<><>><<> WEEK SETUP <> ", day);
                                week.push(day);
                              }
                              const newState = [...state];
                              newState[0].startDate = new Date(week[0]);

                              newState[0].endDate = new Date(
                                week[week.length - 1]
                              );
                              setState(newState);
                              let start = new Date(week[0]);
                              let end = new Date(week[week.length - 1]);
                              start.setHours(0);
                              start.setMinutes(0);
                              start.setSeconds(0);
                              start.setMilliseconds(0);
                              end.setHours(0);
                              end.setMinutes(0);
                              end.setSeconds(0);
                              end.setMilliseconds(0);
                              //for filteration
                              let dateFilter = tempData?.filter((value) => {
                                let tempDate = new Date(value.date);
                                tempDate.setHours(0);
                                tempDate.setMinutes(0);
                                tempDate.setSeconds(0);
                                tempDate.setMilliseconds(0);
                                console.log(
                                  "Date====>>",
                                  tempDate.getFullYear()
                                );
                                return (
                                  tempDate >= start && tempDate <= end && value
                                );
                              });

                              setTransactionHistory(dateFilter);
                            } else if (customSelected) {
                              setYearSelected(false);
                              setMonthSelected(false);
                              setDaySelected(false);
                              setWeekSelected(false);
                              setCustomSelected(true);

                              setRangeType(EnumRanges.CUSTOM_RANGE);

                              const newState = { ...item.selection };

                              //for filteration
                              let dateFilter = tempData?.filter((value) => {
                                console.log("value========", value.date);
                                let tempDate = new Date(value.date);
                                tempDate.setHours(0);
                                tempDate.setMinutes(0);
                                tempDate.setSeconds(0);
                                tempDate.setMilliseconds(0);
                                newState.startDate.setHours(0);
                                newState.startDate.setMinutes(0);
                                newState.startDate.setSeconds(0);
                                newState.startDate.setMilliseconds(0);

                                newState.endDate.setHours(0);
                                newState.endDate.setMinutes(0);
                                newState.endDate.setSeconds(0);
                                newState.endDate.setMilliseconds(0);

                                console.log("time1===>>>", tempDate);
                                console.log("time2===>>>", newState);

                                return (
                                  tempDate >= newState.startDate &&
                                  tempDate <= newState.endDate &&
                                  value
                                );
                              });

                              setTransactionHistory(dateFilter);
                            }
                            // if (weekSelected) {
                            //   // item.selection.endDate = item.selection.startDate;
                            // }
                            setState([item.selection]);
                            console.log("><><>><<><SELECTION <><><> ", item);
                          }}
                          showSelectionPreview={false}
                          showPreview={customSelected} ///// ====== show range preview from - to
                          // moveRangeOnFirstSelection={false}
                          months={2}
                          ranges={state}
                          direction="horizontal"
                          preventSnapRefocus={false}
                          calendarFocus="backwards"
                        />
                      </div>
                    </div>
                    <div class="d-flex flex-column flex-lg-row justify-content-between align-items-center pt-3">
                      <div class="ml-3 n-dateSelected">
                        <strong>Date Range:</strong>{" "}
                        {state[0]?.startDate?.toString().slice(0, 16)} -{" "}
                        {state[0]?.endDate?.toString().slice(0, 16)}
                        {console.log("STATE <>>><><><>><><>< ", state)}
                        {/* Nov 24, 2021 - Dec 24, 2021 */}
                      </div>
                      <div>
                        <button
                          class="mr-2 n-primaryButton n-primaryDark"
                          onClick={() => {
                            setTransactionHistoryFinalized(transactionHistory);
                            console.log(
                              "<><><><><><> THISTORY ><><<> ",
                              transactionHistory
                            );
                            setToggle(false);
                          }}
                        >
                          Apply
                        </button>
                        <button
                          class="ml-2 mr-3 n-secondaryButton"
                          onClick={() => {
                            setToggle(false);
                          }}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className="d-flex flex-row justify-content-center align-items-center">
                  <button
                    className={
                      "btn btn-outline-secondary ml-3 pl-3 " +
                      (rangeType === EnumRanges.CUSTOM_RANGE
                        ? "rangeActive"
                        : "null")
                    }
                    onClick={handleCustom}
                    style={{
                      border: "1px solid",

                      fontSize: "14px",
                      fontFamily: "DM Sans",
                      fontWeight: "bold",
                      borderRadius: "20px",
                    }}
                  >
                    Custom range{" "}
                  </button>
                  <button
                    className={
                      "btn btn-outline-secondary ml-3 pl-3 " +
                      (rangeType === EnumRanges.ONE_DAY ? "rangeActive" : null)
                    }
                    onClick={handleOneDay}
                    className="u-datepickerbuttom56 ml-2"
                  >
                    One day{" "}
                  </button>{" "}
                  <button
                    className={
                      "btn btn-outline-secondary ml-3 pl-3 " +
                      (rangeType === EnumRanges.ONE_WEEK ? "rangeActive" : null)
                    }
                    onClick={handleOneWeek}
                    className="u-datepickerbuttom56 ml-2"
                  >
                    One week
                  </button>
                  <button
                    className={
                      "btn btn-outline-secondary ml-3 pl-3 " +
                      (rangeType === EnumRanges.ONE_MONTH
                        ? "rangeActive"
                        : null)
                    }
                    className="u-datepickerbuttom56 ml-2"
                    onClick={handleOneMonth}
                  >
                    One month
                  </button>
                  <button
                    className={
                      "btn btn-outline-secondary ml-3 pl-3 " +
                      (rangeType === EnumRanges.ONE_YEAR ? "rangeActive" : null)
                    }
                    onClick={handleOneYear}
                    className="u-datepickerbuttom56 ml-2"
                  >
                    One year
                  </button>
                  <button
                    className={
                      "btn btn-outline-secondary ml-3 pl-3 " +
                      (rangeType === EnumRanges.ALL_TIME ? "rangeActive" : null)
                    }
                    onClick={handleAllTime}
                    className="u-datepickerbuttom56 ml-2"
                  >
                    All time
                  </button>
                </div> */}
              </div>
            </div>
          </div>
          {/* <!-- modal end --> */}
        </Modal.Body>
      </Modal>
      <Modal
        show={exportModal}
        onHide={() => {
          setExportModal(false);
        }}
        keyboard={false}
        size="md"
      >
        <Modal.Body>
          {/* <!-- Modal --> */}
          <div
            id="exampleModal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div role="document">
              <div>
                <div
                  class="modal-body"
                  style={{ justifyContent: "center", display: "flex" }}
                >
                  <DateRangePicker
                    onChange={() => {}}
                    showSelectionPreview={false}
                    moveRangeOnFirstSelection={false}
                    months={1}
                    ranges={state}
                    direction="horizontal"
                    preventSnapRefocus={true}
                    calendarFocus="backwards"
                  />
                </div>
                <div style={{ justifyContent: "center", display: "flex" }}>
                  <button
                    className="btn btn-primary btnHoverWhite"
                    onClick={tableToCSV}
                  >
                    Download .CSV
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* <!-- modal end --> */}
        </Modal.Body>
      </Modal>

      <div className="w-sidebarcoleight" style={{ marginBottom: "4px" }}>
        <div className="d-flex flex-row flex-wrap justify-content-between">
          <ul className="list-unstyled d-flex flex-row flex-wrap align-items-center mb-0">
            <li
              className="d-flex flex-row justify-content-center align-items-center"
              style={{ marginRight: "10px" }}
            >
              <button
                className={
                  filterType === Enum.allType
                    ? "alltype alltypesDark"
                    : "alltype-nonActive alltype-nonActiveDark"
                }
                style={{
                  color: "#fff",
                  fontFamily: "DM Sans",
                  whiteSpace: "nowrap",
                }}
                onClick={filterAllType}
              >
                All
              </button>
            </li>
            <li
              className="d-flex flex-row justify-content-center align-items-center"
              style={{ marginRight: "10px" }}
            >
              <button
                className={
                  filterType === Enum.withdraw
                    ? "alltype alltypesDark"
                    : "alltype-nonActive alltype-nonActiveDark"
                }
                style={{ color: "#fff", fontFamily: "DM Sans" }}
                onClick={filterWithdrawType}
              >
                Swap
              </button>
            </li>
            <li
              className="d-flex flex-row justify-content-center align-items-center"
              style={{ marginRight: "10px" }}
            >
              <button
                className={
                  filterType === Enum.addLiquidity
                    ? "alltype alltypesDark"
                    : "alltype-nonActive alltype-nonActiveDark"
                }
                style={{
                  color: "#fff",
                  fontFamily: "DM Sans",
                  whiteSpace: "nowrap",
                }}
                onClick={filterAddLiquidity}
              >
                Liquidity
              </button>
            </li>
            <li
              className="d-flex flex-row justify-content-center align-items-center"
              style={{ marginRight: "10px" }}
            >
              <button
                className={
                  filterType === Enum.pending
                    ? "alltype alltypesDark"
                    : "alltype-nonActive alltype-nonActiveDark"
                }
                style={{ color: "#fff", fontFamily: "DM Sans" }}
                onClick={filterPendingType}
              >
                Withdraw
              </button>
            </li>
            <li
              className="d-inline-block d-sm-flex flex-row justify-content-center align-items-center"
              style={{ marginRight: "16px" }}
            >
              <button
                className={
                  filterType === Enum.deposit
                    ? "alltype n-darkAllType"
                    : "alltype-nonActive n-darkNonActive"
                }
                style={{ color: "#fff" }}
                onClick={filterDepositType}
              >
                Deposit
              </button>
            </li>
            <li
              className="d-flex flex-row justify-content-center align-items-center"
              style={{ marginRight: "10px" }}
            >
              <button
                className={
                  filterType === Enum.refund
                    ? "alltype alltypesDark"
                    : "alltype-nonActive alltype-nonActiveDark"
                }
                style={{ color: "#fff", fontFamily: "DM Sans" }}
                onClick={filterRefundType}
              >
                Refund
              </button>
            </li>
          </ul>
          <form className="n-activitySearch">
            <div class=" d-flex flex-row align-items-center form-group has-search mb-0">
              <input
                type="text"
                class="form-control n-tableSearch n-tableSeachDark"
                placeholder="Search"
                value={searchInput}
                onChange={SearchFilter}
                // style={{ marginRight: "-25px" }}
              />
              {/* <img
                style={{
                  width: "20px",
                  height: "20px",
                  marginRight: "15px",
                  marginTop: "10px",
                  marginBottom: "10px",
                }}
                src={Images.searchicon}
              /> */}
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{
                  width: "20px",
                  height: "20px",
                  marginLeft: "-35px",
                  // marginTop: "10px",
                  // marginBottom: "10px",
                  marginRight: "15px",
                }}
                class="marketSearchIcon n-activitySearchIcon"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M12.4207 13.6002C11.2918 14.4778 9.87327 15.0003 8.33268 15.0003C4.65078 15.0003 1.66602 12.0156 1.66602 8.33366C1.66602 4.65176 4.65078 1.66699 8.33268 1.66699C12.0146 1.66699 14.9993 4.65176 14.9993 8.33366C14.9993 9.87425 14.4768 11.2928 13.5992 12.4217L18.0886 16.9111C18.414 17.2365 18.414 17.7641 18.0886 18.0896C17.7632 18.415 17.2355 18.415 16.9101 18.0896L12.4207 13.6002ZM13.3327 8.33366C13.3327 11.0951 11.0941 13.3337 8.33268 13.3337C5.57126 13.3337 3.33268 11.0951 3.33268 8.33366C3.33268 5.57224 5.57126 3.33366 8.33268 3.33366C11.0941 3.33366 13.3327 5.57224 13.3327 8.33366Z"
                  fill="#777E91"
                />
              </svg>
              {/* <div style={{ float: "right" }}>
                <button
                  class="ml-4 seeallbutton btnHoverBlue"
                  onClick={(e) => {
                    e.preventDefault();

                    setToggle(true);
                  }}
                >
                  All time{" "}
                  <img src={Images.seeall} style={{ paddingLeft: "10px" }} />
                </button>
              </div> */}
            </div>
          </form>
        </div>
        <hr class="solid n-activitySeparator" />
        <div className="d-flex flex-wrap justify-content-between">
          <div className="">
            <h3 className="u-overview09888 mb-0">Activity</h3>
          </div>
          <div
            style={{ float: "right" }}
            class="d-flex flex-wrap n-dateRanger1"
          >
            <button
              class="n-dateRangerButton"
              onClick={(e) => {
                e.preventDefault();

                setToggle(true);
              }}
              style={{ whiteSpace: "nowrap" }}
            >
              Nov 24, 2021 - Dec 24, 2021{" "}
              {/* <img src={Images.seeall} style={{ paddingLeft: "10px" }} /> */}
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="ml-2"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M13.5059 8.16074C13.1805 7.83531 12.6528 7.83531 12.3274 8.16074L10 10.4882L7.67259 8.16074C7.34715 7.83531 6.81951 7.83531 6.49408 8.16074C6.16864 8.48618 6.16864 9.01382 6.49408 9.33926L9.41074 12.2559C9.73618 12.5814 10.2638 12.5814 10.5893 12.2559L13.5059 9.33926C13.8314 9.01382 13.8314 8.48618 13.5059 8.16074Z"
                  fill="#777E91"
                />
              </svg>
            </button>
            <button
              type="button"
              className="btn n-primaryButton n-primaryDark n-exportButton"
              style={{ paddingRight: "16px", whiteSpace: "nowrap" }}
              onClick={() => {
                setExportModal(true);
              }}
            >
              {" "}
              {/* <img src={Images.exportIcon} style={{ marginRight: "11px" }} /> */}
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="mr-2"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M10.4912 9.39461C10.7409 9.66516 10.724 10.0869 10.4535 10.3367L8.12018 12.4905C7.86481 12.7262 7.47118 12.7263 7.21581 12.4905L4.88245 10.3367C4.6119 10.0869 4.59503 9.66517 4.84476 9.39462C5.0945 9.12407 5.51627 9.1072 5.78682 9.35693L7.00133 10.478L7.00132 4.00065C7.00132 3.63246 7.2998 3.33398 7.66799 3.33398C8.03618 3.33398 8.33466 3.63246 8.33466 4.00065L8.33466 10.478L9.54911 9.35694C9.81965 9.1072 10.2414 9.12407 10.4912 9.39461Z"
                  fill="#FCFCFD"
                />
              </svg>
              Export
            </button>
          </div>
        </div>
        <div className="w-portfoilo-tb">
          <div className="table-responsive w-comon-table-style">
            <table className="table">
              <thead>
                <tr>
                  <th scope="col">
                    <span>Type</span>
                    <div
                      style={{
                        display: "contents",
                        marginLeft: "3px",
                      }}
                      onClick={handleDescendingType}
                    >
                      <svg
                        width="17"
                        height="16"
                        viewBox="0 0 17 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ cursor: "pointer", margin: "0px 0px 2px 0px" }}
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M5.66206 6.80539C5.92241 7.06574 6.34452 7.06574 6.60487 6.80539L8.4668 4.94346L10.3287 6.80539C10.5891 7.06574 11.0112 7.06574 11.2715 6.80539C11.5319 6.54504 11.5319 6.12293 11.2715 5.86258L8.9382 3.52925C8.67785 3.2689 8.25574 3.2689 7.99539 3.52925L5.66206 5.86258C5.40171 6.12293 5.40171 6.54504 5.66206 6.80539Z"
                          fill="#777E91"
                        ></path>
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M5.66206 9.19461C5.92241 8.93426 6.34452 8.93426 6.60487 9.19461L8.4668 11.0565L10.3287 9.19461C10.5891 8.93426 11.0112 8.93426 11.2715 9.19461C11.5319 9.45496 11.5319 9.87707 11.2715 10.1374L8.9382 12.4708C8.67785 12.7311 8.25574 12.7311 7.99539 12.4708L5.66206 10.1374C5.40171 9.87707 5.40171 9.45496 5.66206 9.19461Z"
                          fill="#777E91"
                          src={Images.FilterDown}
                        ></path>
                      </svg>
                    </div>
                  </th>
                  <th scope="col">
                    <span>Coin</span>
                    <div
                      style={{
                        display: "contents",
                        marginLeft: "3px",
                      }}
                      onClick={handleAscendingDescendingCoin}
                    >
                      <svg
                        width="17"
                        height="16"
                        viewBox="0 0 17 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ cursor: "pointer", margin: "0px 0px 2px 0px" }}
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M5.66206 6.80539C5.92241 7.06574 6.34452 7.06574 6.60487 6.80539L8.4668 4.94346L10.3287 6.80539C10.5891 7.06574 11.0112 7.06574 11.2715 6.80539C11.5319 6.54504 11.5319 6.12293 11.2715 5.86258L8.9382 3.52925C8.67785 3.2689 8.25574 3.2689 7.99539 3.52925L5.66206 5.86258C5.40171 6.12293 5.40171 6.54504 5.66206 6.80539Z"
                          fill="#777E91"
                          // onClick={handleDescendingCoin}
                          style={{ cursor: "pointer" }}
                        ></path>
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M5.66206 9.19461C5.92241 8.93426 6.34452 8.93426 6.60487 9.19461L8.4668 11.0565L10.3287 9.19461C10.5891 8.93426 11.0112 8.93426 11.2715 9.19461C11.5319 9.45496 11.5319 9.87707 11.2715 10.1374L8.9382 12.4708C8.67785 12.7311 8.25574 12.7311 7.99539 12.4708L5.66206 10.1374C5.40171 9.87707 5.40171 9.45496 5.66206 9.19461Z"
                          fill="#777E91"
                          // onClick={handleAscendingCoin}
                        ></path>
                      </svg>
                    </div>
                  </th>
                  <th scope="col">
                    <span>Amount</span>{" "}
                    <div
                      style={{
                        display: "contents",
                        marginLeft: "3px",
                      }}
                      onClick={handleAscendingDescendingAmount}
                    >
                      <svg
                        width="17"
                        height="16"
                        viewBox="0 0 17 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ cursor: "pointer", margin: "0px 0px 2px 0px" }}
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M5.66206 6.80539C5.92241 7.06574 6.34452 7.06574 6.60487 6.80539L8.4668 4.94346L10.3287 6.80539C10.5891 7.06574 11.0112 7.06574 11.2715 6.80539C11.5319 6.54504 11.5319 6.12293 11.2715 5.86258L8.9382 3.52925C8.67785 3.2689 8.25574 3.2689 7.99539 3.52925L5.66206 5.86258C5.40171 6.12293 5.40171 6.54504 5.66206 6.80539Z"
                          fill="#777E91"
                          // onClick={handleDescendingAmount}
                        ></path>
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M5.66206 9.19461C5.92241 8.93426 6.34452 8.93426 6.60487 9.19461L8.4668 11.0565L10.3287 9.19461C10.5891 8.93426 11.0112 8.93426 11.2715 9.19461C11.5319 9.45496 11.5319 9.87707 11.2715 10.1374L8.9382 12.4708C8.67785 12.7311 8.25574 12.7311 7.99539 12.4708L5.66206 10.1374C5.40171 9.87707 5.40171 9.45496 5.66206 9.19461Z"
                          fill="#777E91"
                          // onClick={handleAscendingAmount}
                        ></path>
                      </svg>
                    </div>
                  </th>
                  <th scope="col">
                    <span>Address</span>{" "}
                    <div
                      style={{
                        display: "contents",
                        marginLeft: "3px",
                      }}
                      onClick={handleAscendingDescendingAddress}
                    >
                      <svg
                        width="17"
                        height="16"
                        viewBox="0 0 17 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ cursor: "pointer", margin: "0px 0px 2px 0px" }}
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M5.66206 6.80539C5.92241 7.06574 6.34452 7.06574 6.60487 6.80539L8.4668 4.94346L10.3287 6.80539C10.5891 7.06574 11.0112 7.06574 11.2715 6.80539C11.5319 6.54504 11.5319 6.12293 11.2715 5.86258L8.9382 3.52925C8.67785 3.2689 8.25574 3.2689 7.99539 3.52925L5.66206 5.86258C5.40171 6.12293 5.40171 6.54504 5.66206 6.80539Z"
                          fill="#777E91"
                          // onClick={handleDescendingAddress}
                        ></path>
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M5.66206 9.19461C5.92241 8.93426 6.34452 8.93426 6.60487 9.19461L8.4668 11.0565L10.3287 9.19461C10.5891 8.93426 11.0112 8.93426 11.2715 9.19461C11.5319 9.45496 11.5319 9.87707 11.2715 10.1374L8.9382 12.4708C8.67785 12.7311 8.25574 12.7311 7.99539 12.4708L5.66206 10.1374C5.40171 9.87707 5.40171 9.45496 5.66206 9.19461Z"
                          fill="#777E91"
                          // onClick={handleAscendingAddress}
                        ></path>
                      </svg>
                    </div>
                  </th>
                  <th scope="col">
                    <span>Transaction ID</span>
                    <div
                      style={{
                        display: "contents",
                        marginLeft: "3px",
                      }}
                      onClick={handleAscendingDescendingTransactionID}
                    >
                      <svg
                        width="17"
                        height="16"
                        viewBox="0 0 17 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ cursor: "pointer", margin: "0px 0px 2px 0px" }}
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M5.66206 6.80539C5.92241 7.06574 6.34452 7.06574 6.60487 6.80539L8.4668 4.94346L10.3287 6.80539C10.5891 7.06574 11.0112 7.06574 11.2715 6.80539C11.5319 6.54504 11.5319 6.12293 11.2715 5.86258L8.9382 3.52925C8.67785 3.2689 8.25574 3.2689 7.99539 3.52925L5.66206 5.86258C5.40171 6.12293 5.40171 6.54504 5.66206 6.80539Z"
                          fill="#777E91"
                          // onClick={handleDescendingTransactionID}
                        ></path>
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M5.66206 9.19461C5.92241 8.93426 6.34452 8.93426 6.60487 9.19461L8.4668 11.0565L10.3287 9.19461C10.5891 8.93426 11.0112 8.93426 11.2715 9.19461C11.5319 9.45496 11.5319 9.87707 11.2715 10.1374L8.9382 12.4708C8.67785 12.7311 8.25574 12.7311 7.99539 12.4708L5.66206 10.1374C5.40171 9.87707 5.40171 9.45496 5.66206 9.19461Z"
                          fill="#777E91"
                          // onClick={handleAscendingTransactionID}
                        ></path>
                      </svg>
                    </div>
                  </th>
                  <th scope="col">
                    <span>Date</span>
                  </th>
                </tr>
              </thead>

              <tbody>
                {transactionHistoryFinalized?.length ? (
                  <>
                    {transactionHistoryFinalized.map((t, key) => {
                      return (
                        <tr>
                          <td>
                            <div className="d-flex flex-column">
                              <div>
                                <span
                                  style={{ fontFamily: "Poppins" }}
                                  className={
                                    t.Type === "Withdraw"
                                      ? ""
                                      : "depositclasssliquid"
                                  }
                                >
                                  {t.type.toUpperCase()}
                                </span>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div className="d-flex ">
                              {gettingLogos(t)}
                              <div
                                style={{
                                  paddingLeft: "5px",
                                  fontFamily: "Poppins",
                                  fontSize: "14px",
                                  marginTop: "3px",
                                }}
                              >
                                <span class="n-tabelDark">
                                  {t.asset.ticker}
                                </span>
                              </div>
                              <div className="d-flex align-items-center"></div>
                            </div>
                          </td>
                          <td>
                            <span class="n-tabelDark">{t.transferAmount}</span>
                            {/* {t.to[0].amount.amount().c[0]} */}
                          </td>
                          <td>
                            <div className="d-flex flex-column">
                              <div>
                                <span class="n-tabelDark">{t?.to[0]?.to}</span>
                              </div>
                            </div>
                          </td>
                          <td>
                            <span
                              class="n-tabelDark w-port-link"
                              style={{ cursor: "pointer" }}
                            >
                              {/* {t?.hash?.substring(0, 7)}...
                               */}

                              {viewBlockLink(t)}
                            </span>
                          </td>
                          <td>
                            <span
                              class="n-tabelDark"
                              style={{ whiteSpace: "nowrap", color: "#777e90" }}
                            >
                              {new Date(t?.date)?.toString().substring(0, 24)}
                            </span>
                          </td>
                        </tr>
                      );
                    })}
                  </>
                ) : (
                  <tr>
                    <td
                      colspan="6"
                      class="text-center text-muted"
                      style={{ padding: "148px 0px" }}
                    >
                      <div className="w-no-data-tb">No Transaction Found</div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Activity;
